<div class="container sixth-container mt-100px">
  <div class="container-title-div">
    <span class="sixth-container-title"
          [ngClass]="{'sixth-container-title-am': currentLang === Language.HY}">{{ 'home-page-content.choose_digital_card' | translate }}</span>
    <span class="sixth-container-subtitle"
          [ngClass]="{'sixth-container-subtitle-am mt-4': currentLang === Language.HY, 'sixth-container-subtitle-ru mt-4': currentLang === Language.RU }">{{ 'home-page-content.choose_digital_card_info' | translate }}</span>
  </div>

  <div class="row d-flex align-items-center">
    <div class="width-55">
      <img src="assets/homepage/choose-digital-business-card/first.png" alt="sixth section first pic"
           class="sixth-section-first-pic ">
    </div>
    <div class="d-flex for-individuals for-individuals-lg">
      <span class="sixth-container-title"
            [ngClass]="{'sixth-container-title-am': currentLang === Language.HY, 'sixth-container-ru': currentLang === Language.RU}">{{ 'home-page-content.for_individuals' | translate }}</span>
      <div class="flex-direction-column">
        @for (individualItem of individualsItems; track individualItem) {
          <div class="sixth-container-row">
            <img [src]="individualItem.image" alt="check svg">
            <span class="sixth-span-class">{{ individualItem.content | translate }}</span>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="row d-flex align-items-center">
    <div class="d-flex for-individuals for-teams-lg">
      <span class="sixth-container-title"
            [ngClass]="{'sixth-container-title-am': currentLang === Language.HY,}">{{ 'home-page-content.for_teams' | translate }}</span>
      <div class="flex-direction-column">
        @for (teamItem of teamsItems; track teamItem) {
          <div class="sixth-container-row" [ngClass]="{'sixth-container-row-ru': currentLang === Language.RU}">
            <img [src]="teamItem.image" alt="check svg">
            <span class="sixth-span-class">{{ teamItem.content | translate }}</span>
          </div>
        }
      </div>
    </div>
    <div class="sixth-section-second-pic-container width-55">
      <img src="assets/homepage/choose-digital-business-card/second.png" alt="sixth section second pic">
    </div>
  </div>
</div>

<section class="section-wrapper-mb sixth-container-mb mt-100px">
  <div class="flex-direction-column">
    <div class="container-title-div">
      <span
        class="sixth-container-title sixth-container-global-title">{{ 'home-page-content.choose_digital_card' | translate }}</span>
      <span class="sixth-container-subtitle mt-">{{ 'home-page-content.choose_digital_card_info' | translate }}</span>
    </div>
    <img src="assets/homepage/choose-digital-business-card/first-mb.png" alt="sixth section first image" class="mt-3">
    <div class="d-flex for-individuals i-width-100 mt-30px">
      <span class="sixth-container-title">{{ 'home-page-content.for_individuals' | translate }}</span>
      <div class="flex-direction-column">
        @for (individualItem of individualsItems; track individualItem) {
          <div class="sixth-container-row align-items-start">
            <img [src]="individualItem.image" alt="check svg" class="img_margin mt-1">
            <span class="sixth-span-class">{{ individualItem.content | translate }}</span>
          </div>
        }
      </div>
    </div>

    <img src="assets/homepage/choose-digital-business-card/second-mb.png" alt="sixth section second image" class="mt-4">
    <div class="d-flex for-individuals i-width-100 mt-30px">
      <span class="sixth-container-title">{{ 'home-page-content.for_teams' | translate }}</span>
      <div class="flex-direction-column">
        @for (teamItem of teamsItems; track teamItem) {
          <div class="sixth-container-row align-items-start">
            <img [src]="teamItem.image" alt="check svg" class="mt-negative-14 mt-1">
            <span class="sixth-span-class">{{ teamItem.content | translate }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</section>
